import React from "react";
import { CompanySettingsContainer } from "../../containers";

const CompanySettings = (props) => {
  return <CompanySettingsContainer {...props} />;
};

export default CompanySettings;
